import { Button } from 'antd';
import React, { useContext, useEffect, useState } from 'react';
import EmpresaContext from '../context/empresa-context';
import UserContext from '../context/user-context';
import WhatsAppContext from '../context/whatsapp-context';
import './WhatsAppButton.css';

const WhatsAppButton = () => {
  const [descripcionEmpresa, setDescripcionEmpresa] = useState('Sin definir');
  const [descripcionProducto, setDescripcionProducto] = useState('Sin definir');
  const [whatsapp, setWhatsapp] = useState(null);
  const { empresa, producto, productos, getProductoActual } = useContext(
    EmpresaContext
  );
  const { user } = useContext(UserContext);
  const [textoFinal, setTextoFinal] = useState('');
  const { texto } = useContext(WhatsAppContext);

  useEffect(() => {
    if (empresa && empresa.nombre) {
      setDescripcionEmpresa(empresa.nombre);
    }
  }, [empresa]);

  useEffect(() => {
    if (producto > 0 && productos && productos.length > 0) {
      setDescripcionProducto(getProductoActual().descripcion);
    }
  }, [producto, productos, getProductoActual]);

  useEffect(() => {
    if (!empresa?.id) {
      // No empresa -> no button
      setWhatsapp(undefined);
      setTextoFinal('');
      return;
    }

    // Safely get producto actual once
    const productoActual =
      typeof getProductoActual === 'function' ? getProductoActual() : null;

    // Try to extract WhatsApp from producto-empresa mapping
    const matchWhatsapp = productoActual?.empresaProducto?.find?.(
      (item) => item?.id_empresa === empresa.id
    )?.whatsapp;

    const fallbackWhatsapp = empresa?.whatsapp;

    const whatsappToUse = matchWhatsapp || fallbackWhatsapp;
    if (!whatsappToUse) {
      setWhatsapp(undefined);
      setTextoFinal('');
      return;
    }

    setWhatsapp(whatsappToUse);
    const defaultMsg =
      '¡Hola!. Necesito ayuda con un seguro. ¿Me podrían orientar por favor?';

    const message = matchWhatsapp
      ? `Empresa: ${descripcionEmpresa}.\nProducto: ${descripcionProducto}.\n${texto}\n\n`
      : defaultMsg;

    setTextoFinal(message);
  }, [
    empresa,
    getProductoActual,
    descripcionEmpresa,
    descripcionProducto,
    texto
  ]);

  const url = `https://wa.me/${whatsapp}?text=${encodeURIComponent(
    textoFinal
  )}`;

  const isClienteOrNotLogged =
    !user || user['cognito:groups']?.[0] === 'CLIENTE';

  return (
    <>
      {whatsapp && isClienteOrNotLogged && (
        <Button
          id="floating_button_sirena"
          className="widget_bg1 right"
          type="primary"
          shape="circle"
          size="large"
          icon={
            <img
              src="/images/whatsapp-logo.png"
              alt="WhatsApp logo"
              id="widget_logo"
              className="wa-icon"
            />
          }
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Contactar por WhatsApp"
          style={{ right: 10 }}
        />
      )}
    </>
  );
};

export default WhatsAppButton;
